import * as THREE from 'three/webgpu';
import { PointsMaterialFactory } from '../../../../material/PointsMaterialFactory';
import type { SketchGroup } from '../../../../mesh/sketch/SketchGroup';
import {
	SketchPointKind,
} from '../../../../mesh/sketch/ISketchObject';
import { SketchLineObject } from '../../../../mesh/sketch/SketchLineObject';
import { SketchPointObject } from '../../../../mesh/sketch/SketchPointObject';
import type { ProjectionResult } from '../../model/ProjectionResult';
import type {
	LineReferenceBuilderInput,
} from '../../../../../types/reference/sketch-entity-reference/LineReferenceBuilder';

export type {
	LineReferenceBuilderInput,
} from '../../../../../types/reference/sketch-entity-reference/LineReferenceBuilder';

/**
 * 直线引用构建器。
 * 说明：
 * 1. 只消费 `ProjectionResult` 中的直线几何载荷；
 * 2. 负责创建线实体及其起终点控制点；
 * 3. 不参与实体挂载，挂载由 factory 统一收口。
 */
export class LineReferenceBuilder {
	/**
	 * 基于投影结果构建目标直线实体。
	 *
	 * @param input 构建输入。
	 * @returns 已初始化完成的草图直线对象。
	 */
	public build(input: LineReferenceBuilderInput): SketchLineObject {
		const startPoint = createControlPoint(input.geometryPayload.startWorld, input.targetSketch);
		const endPoint = createControlPoint(input.geometryPayload.endWorld, input.targetSketch);

		return new SketchLineObject({
			referencePlane: input.targetSketch.referencePlane,
			startPoint,
			endPoint,
		});
	}
}

/**
 * 创建引用链路使用的控制点。
 *
 * @param position 世界坐标。
 * @param targetSketch 目标草图。
 * @returns 控制点对象。
 */
function createControlPoint(
	position: import('../../model/ProjectionResult').WorldCoordinate,
	targetSketch: SketchGroup,
): SketchPointObject {
	return new SketchPointObject({
		position: new THREE.Vector3(position[0], position[1], position[2]),
		pointKind: SketchPointKind.ControlPoint,
		material: PointsMaterialFactory.getSketchControlPointSpriteMaterial(),
		referencePlane: targetSketch.referencePlane,
	});
}
